import { t } from "@/i18n-js/instance";
import { dateIsPast } from "@circle-react/helpers/dateTimeHelpers";
import { ROOM_ACCESS_TYPES } from "@circle-react/helpers/liveStreamRoomHelpers";
import type { Event } from "@circle-react/types/Event";
import { EVENT_TYPES, LOCATION_TYPES, STATUS, TICKET_TYPES } from "./constants";

export const isDraft = (event: Event | null) => event?.status === STATUS.DRAFT;
export const isPublished = (event: Event | null | undefined) =>
  event?.status === STATUS.PUBLISHED;
export const isRecurring = (event: Event | null) =>
  event?.event_type === EVENT_TYPES.RECURRING;
export const isSingle = (event: Event | null) =>
  event?.event_type === EVENT_TYPES.SINGLE;
export const isLiveRoom = (event: Event | null | undefined) =>
  event?.event_setting_attributes?.location_type === LOCATION_TYPES.LIVE_ROOM;
export const isLiveStream = (event: Event | null) =>
  event?.event_setting_attributes?.location_type === LOCATION_TYPES.LIVE_STREAM;
export const isPublicStream = (event: Event | null) =>
  isLiveStream(event) &&
  event?.event_setting_attributes?.live_stream_room_setting_attributes
    ?.access_type === ROOM_ACCESS_TYPES.PUBLIC_STREAM;
export const isLiveLocation = (locationType: string) =>
  [LOCATION_TYPES.LIVE_STREAM, LOCATION_TYPES.LIVE_ROOM].includes(locationType);
export const hasEventEnded = (event: Event | null) =>
  Boolean(event && dateIsPast(event?.event_setting_attributes?.ends_at));
export const hasEventStarted = (event: Event | null) =>
  Boolean(event && dateIsPast(event?.event_setting_attributes?.starts_at));
export const isPaidEvent = (event: Event | null) =>
  event?.event_setting_attributes?.ticket_type == TICKET_TYPES.PAID;
export const eventWithPublishedPaywall = (event: Event | null) =>
  event && event?.paywall_attributes?.published;
export const isRecurringFreeEvent = (event: Event | null) =>
  isRecurring(event) && !isPaidEvent(event);
export const isPastOrDraft = (event: Event | null) =>
  hasEventEnded(event) || isDraft(event);
export const eventDeletionMessage = (event: Event | null) => {
  const isRecurringEvent = isRecurring(event);

  let message = isRecurringEvent
    ? t("events.recurring_deletion_successful")
    : t("event_dropdown_actions.delete_successful");

  if (isPastOrDraft(event)) {
    message = isRecurringEvent
      ? t("events.recurring_draft_deletion_successful")
      : t("event_dropdown_actions.draft_delete_successful");
  }
  return message;
};
